import type { SVGProps } from 'react';
import { isNamedIconName, namedIconRegistry } from './namedIconRegistry';

export interface NamedIconProps extends Omit<SVGProps<SVGSVGElement>, 'name'> {
  name: string;
  size?: number;
}

const NamedIcon = ({ name, size, ...svgProps }: NamedIconProps) => {
  if (!isNamedIconName(name)) {
    return null;
  }

  const Icon = namedIconRegistry[name];

  return <Icon {...svgProps} height={size} width={size} />;
};

export { NamedIcon };
